import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { Sun, Moon } from "lucide-react";

const Ctx = createContext(null);

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(() => localStorage.getItem("rp_theme") || "light");
  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    document.documentElement.style.colorScheme = theme;
  }, [theme]);
  const value = useMemo(() => {
    const listeners = new Set();
    return {
      theme,
      setTheme: (t, silent) => {
        localStorage.setItem("rp_theme", t);
        setThemeState(t);
        if (!silent) listeners.forEach((fn) => fn(t));
      },
      onChange: (fn) => {
        listeners.add(fn);
        return () => listeners.delete(fn);
      },
    };
  }, [theme]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export const useTheme = () => useContext(Ctx);

export const ThemeToggle = ({ className = "", label }) => {
  const { theme, setTheme } = useTheme();
  const next = theme === "dark" ? "light" : "dark";
  return (
    <button
      type="button"
      data-testid="theme-toggle"
      aria-label={next}
      onClick={() => setTheme(next)}
      className={`inline-flex items-center gap-2 min-h-[44px] rounded-xl px-3 text-sm font-medium text-muted-foreground hover:bg-secondary hover:text-foreground transition-colors ${className}`}
    >
      {theme === "dark" ? <Sun className="w-5 h-5 shrink-0" /> : <Moon className="w-5 h-5 shrink-0" />}
      {label && <span>{label}</span>}
    </button>
  );
};
